import {   post } from "../../service/api";

const SettleTransaction = async (transactionId) => {
    try {
        const response = await post(`/transaction/${transactionId}/settle`);
        return response;
    } catch (error) {
        console.error('Error SettleTransaction:', error);
        throw error;
    }
};

export default SettleTransaction;